import React, { useEffect } from "react";

import useHttp from "../hooks/useHttp";
import { GET_USER_REVIEWS_URL } from "../utils/api-ends";
import Rating from "./Rating";
import LoaderImg from "../assets/media/loader.gif";

const UserReviews = ({ userId }) => {
  const [reviews, setReviews] = React.useState({});
  const { isLoading, sendRequests: fetchReviews } = useHttp();
  const { isLoading: loadingSeeMore, sendRequests: seeMoreReviews } = useHttp();

  useEffect(() => {
    const response = (data) => {
      setReviews(data);
    };

    fetchReviews(
      {
        url: GET_USER_REVIEWS_URL(userId),
      },
      response
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const seeMoreData = () => {
    if (reviews?.pagination?.next_page_number) {
      const response = (data) => {
        setReviews((prevR) => {
          return {
            pagination: data.pagination,
            results: [...prevR.results, ...data.results],
          };
        });
      };
      seeMoreReviews(
        {
          url: GET_USER_REVIEWS_URL(
            userId,
            reviews?.pagination?.next_page_number
          ),
        },
        response
      );
    }
  };

  if (!reviews?.results?.length) {
    return (
      <section id="review-section">
        <div className="d-flex container theme-section justify-content-center">
          <h5>No Reviews Found</h5>
        </div>
      </section>
    );
  }

  return (
    <section id="review-section">
      <div className="container theme-section review-box-pendding">
        <h1 className="section-tittle">
          User Review ({reviews?.pagination?.total_value})
        </h1>

        {isLoading && (
          <div className="loader d-flex justify-content-center">
            <img style={{ width: "35px" }} src={LoaderImg} alt="" />
          </div>
        )}

        <div className="mb-5 add-pendding-left">
          {reviews?.results?.map((review) => (
            <div className="row review-box-wrapper">
              <div className="col-xl-3 col-lg-4 mb-3">
                <div className="user-image-rating">
                  <div className="reivew-user-img">
                    <img
                      src={review?.from_user_obj?.profile_picture_url}
                      alt=""
                    />
                  </div>
                  <div className="user-name-rate">
                    <p>{review?.from_user_obj?.username}</p>
                    <div className="rating-star">
                      <Rating rating={review?.review_rating} />
                    </div>
                    <span>{review?.created_at}</span>
                  </div>
                </div>
              </div>

              <div
                className="col-xl-9 col-lg-8 the-review-text"
                show-more="false"
              >
                <p>{review?.review_text}</p>
                {/* <span className="see-more-less-btn">(See More)</span> */}
              </div>
            </div>
          ))}
        </div>

        {reviews?.pagination?.next_page_number && (
          <div className="multiple-btn">
            <button onClick={seeMoreData}>
              See More Reviews
              {loadingSeeMore && (
                <img style={{ width: "20px" }} src={LoaderImg} alt="" />
              )}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default UserReviews;
